import wcad1 from "../../assets/wcad1.png";
import wcad2 from "../../assets/wcad2.png";
import wcad3 from "../../assets/wcad3.png";
import teamex1 from "../../assets/teamex1.png";





export const wcapmsdcard = [
    {
      img: <img src={wcad1} alt="img" />,
      wcad: " Manage",
      txt: "Buy and check your credit balance"
    },
    {
      img: <img src={wcad2} alt="img" />,
      wcad: " Monitor",
      txt: "monitor your power consumption"
    },
    {
      img: <img src={wcad3} alt="img" />,
      wcad: " Control",
      txt: "shut off power supply "
    },
  ];
  
  export const Mteam = [
    {
      img: <img src={teamex1} alt="img" />,
      name: " Sodiq Faran A",
    },
    {
      img: <img src={teamex1} alt="img" />,
      name: " Johnson Goodness O ",
    },
    {
      img: <img src={teamex1} alt="img" />,
      name: " Eniojukan Daniel O",
    },
    {
      img: <img src={teamex1} alt="img" />,
      name: " Damilare Taofeek O",
    },
    {
      img: <img src={teamex1} alt="img" />,
      name: " Tella Goodness O",
    },
    {
      img: <img src={teamex1} alt="img" />,
      name: " Owoleke Victor F",
    },
  ];
  